import { UPDATE_AUTH, UPDATE_USER_DETAILS, USER_LOGOUT } from '../types'

const INITIAL_STATE = {
  auth: {},
  error: '',
  isLoggedIn: false,
  redirectPath: '/login',
  user: {},
}

const authReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_AUTH:
      return {
        ...state,
        ...payload,
      }
    case UPDATE_USER_DETAILS:
      return {
        ...state,
        user: {
          ...state.user,
          ...payload,
        },
      }
    case USER_LOGOUT:
      return {
        ...INITIAL_STATE,
      }
    default:
      return state
  }
}

export default authReducer
